<template>
  <q-card flat>
    <q-card-section class="no-padding" >
      <q-banner class="bg-blue text-white">
        لیست حواله های شش ماه اخیر
        <template v-slot:avatar>
          <q-icon name="list"/>
        </template>
      </q-banner>
      <q-toggle v-model="saleKind"
                :false-value="true"
                :true-value="false"
                :label="saleKind?'مشاهده لیست حواله های برگشتی':'مشاهده لیست حواله ها'" />
    </q-card-section>
    <q-card-section class="no-padding" >
      <FactorHistory :show-only-exit-document="true" v-if="$q.screen.lt.md" :order-history-list.sync="items" :is-dialog="false"/>
      <FactorHistoryDesktop  :show-only-exit-document="true" v-if="!$q.screen.lt.md" :order-history-list.sync="items" :is-dialog="false"/>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import FactorHistory from "@/components/Factor/FactorHistory";
import EventBus from "@/event-bus";
import FactorHistoryDesktop from "@/components/Factor/FactorHistoryDesktop";

export default {
  name: "ExitDocumentList",
  components: {FactorHistoryDesktop, FactorHistory},
  data() {
    return {
      items: [],
      saleKind: true
    }
  },
  methods: {
    ...mapActions({
      getFactorList: 'Orders/getFactors'
    }),
    loadDate(){
      this.getFactorList({
        cs_id: -1,
        saleKind: this.saleKind === true ? 1 : -1
      }).then((res) => {
        this.items = res
        EventBus.$emit('invoke-factor-list', this.items);
      })
    }
  },
  watch:{
    saleKind:function (){
      this.loadDate()
    }
  },
  created() {
    this.loadDate()
  }
}
</script>

<style scoped>
.fixed-header-position {
  position: sticky;
  top: 50px;
  z-index: 1000;
}
</style>